import script from "./ColumnPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnPreview.vue?vue&type=style&index=0&id=d9ba57ea&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ba57ea"]])

export default __exports__